import { module } from 'angular';
import { $log } from 'ngimport';
import { KayentaAnalysisType } from 'kayenta/domain';
class ForAnalysisTypeController {
    constructor() {
        this.showForAnalysisType = () => {
            if (!this.stage) {
                $log.warn('No stage bound to <for-analysis-type> component');
            }
            if (!this.types) {
                $log.warn('No types bound to <for-analysis-type> component');
            }
            return (this.types || '')
                .split(',')
                .map((type) => {
                const val = type.trim();
                if (![
                    KayentaAnalysisType.Retrospective,
                    KayentaAnalysisType.RealTime,
                    KayentaAnalysisType.RealTimeAutomatic,
                ].includes(val)) {
                    $log.warn(`${val} is not a Kayenta analysis type.`);
                }
                return val;
            })
                .includes(this.stage.analysisType);
        };
    }
}
export const FOR_ANALYSIS_TYPE_COMPONENT = 'spinnaker.kayenta.forAnalysisType.component';
module(FOR_ANALYSIS_TYPE_COMPONENT, []).component('forAnalysisType', {
    bindings: {
        types: '@',
        stage: '<',
    },
    controller: ForAnalysisTypeController,
    transclude: true,
    template: '<ng-transclude ng-if="$ctrl.showForAnalysisType()"></ng-transclude>',
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9yQW5hbHlzaXNUeXBlLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9rYXllbnRhL3N0YWdlcy9rYXllbnRhU3RhZ2UvZm9yQW5hbHlzaXNUeXBlLmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQXdCLE1BQU0sRUFBRSxNQUFNLFNBQVMsQ0FBQztBQUN2RCxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBQ2hDLE9BQU8sRUFBaUIsbUJBQW1CLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUVwRSxNQUFNLHlCQUF5QjtJQUEvQjtRQUlTLHdCQUFtQixHQUFHLEdBQVksRUFBRTtZQUN6QyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRTtnQkFDZixJQUFJLENBQUMsSUFBSSxDQUFDLGlEQUFpRCxDQUFDLENBQUM7YUFDOUQ7WUFDRCxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRTtnQkFDZixJQUFJLENBQUMsSUFBSSxDQUFDLGlEQUFpRCxDQUFDLENBQUM7YUFDOUQ7WUFFRCxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssSUFBSSxFQUFFLENBQUM7aUJBQ3RCLEtBQUssQ0FBQyxHQUFHLENBQUM7aUJBQ1YsR0FBRyxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUU7Z0JBQ1osTUFBTSxHQUFHLEdBQUcsSUFBSSxDQUFDLElBQUksRUFBeUIsQ0FBQztnQkFDL0MsSUFDRSxDQUFDO29CQUNDLG1CQUFtQixDQUFDLGFBQWE7b0JBQ2pDLG1CQUFtQixDQUFDLFFBQVE7b0JBQzVCLG1CQUFtQixDQUFDLGlCQUFpQjtpQkFDdEMsQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLEVBQ2Y7b0JBQ0EsSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLEdBQUcsa0NBQWtDLENBQUMsQ0FBQztpQkFDckQ7Z0JBQ0QsT0FBTyxHQUFHLENBQUM7WUFDYixDQUFDLENBQUM7aUJBQ0QsUUFBUSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsWUFBWSxDQUFDLENBQUM7UUFDdkMsQ0FBQyxDQUFDO0lBQ0osQ0FBQztDQUFBO0FBRUQsTUFBTSxDQUFDLE1BQU0sMkJBQTJCLEdBQUcsNkNBQTZDLENBQUM7QUFDekYsTUFBTSxDQUFDLDJCQUEyQixFQUFFLEVBQUUsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxpQkFBaUIsRUFBRTtJQUNuRSxRQUFRLEVBQUU7UUFDUixLQUFLLEVBQUUsR0FBRztRQUNWLEtBQUssRUFBRSxHQUFHO0tBQ1g7SUFDRCxVQUFVLEVBQUUseUJBQXlCO0lBQ3JDLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFFBQVEsRUFBRSxxRUFBcUU7Q0FDaEYsQ0FBQyxDQUFDIn0=